export default __webpack_public_path__ + "static/media/bannerIllustration.3fe9383f.png";